'use client';

import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from 'next-themes';

/**
 * next-themes renders its own no-flash script from inside this provider — a
 * client component. React 19 never executes a `<script>` created during a
 * client render and warns about it in dev, so that copy is inert noise; the
 * server-rendered one in `lib/theme-boot.ts` is what actually runs.
 *
 * Giving it a non-JavaScript `type` makes React treat it as a data block and
 * stop warning (see `isScriptDataBlock` in react-dom). It also makes the
 * server-rendered copy inert, which is why `THEME_BOOT_SCRIPT` has to be
 * mounted in `app/layout.tsx` for this to be safe.
 */
export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      scriptProps={{ type: 'application/x-theme-boot-superseded' }}
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
